import { Component, Input, OnInit, TemplateRef, ViewChild, ViewChildDecorator } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  ComponentNamesForUserConfiguration,
  IComponentConfiguration,
  IUserConfiguration,
  UserConfigurationStateInterface,
} from '../../../store/user-configuration/user-configuration.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as UserActions from '../../../store/settings/users/users.actions';
import * as DeviceActions from '../../../store/device/device.actions';
import { ActionsSubject, Store } from '@ngrx/store';
import { IotDeviceManagementPortalAppState } from '../../../store/iotDeviceManagementPortalApp.reducer';
import { PageHeaderInterface } from '../../service/page-header/page-header.model';
import { Subscription } from 'rxjs';
import {
  PageConfigurationInterface, TableColumnInterface,
  TableConfigurationInterface,
  WidgetConfigurationInterface, WidgetDataInterface,
} from './page-configuration.model';
import * as _ from 'lodash';
import { HelperService } from '../../service/helper.service';
import { ITableHeader, PageConfigurationTypes } from '../../../../constants.model';
import { TabRowInterface } from '../side-config-bar/side-config-bar.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ScwMatButtonGroupButtons } from '../scw-mat-ui/scw-mat-button-group/scw-mat-button-group.model';
import * as PageHeaderActions from '../../../store/page-header/page-header.actions';

@Component({
  selector: 'app-page-configuration',
  templateUrl: './page-configuration.component.html',
  styleUrls: ['./page-configuration.component.scss'],
})
export class PageConfigurationComponent implements OnInit {
  @ViewChild('close_button') closeButtonRef: ViewChild;
  @ViewChild('unsaved_modal') unsavedChangesModalTemplateRef: ViewChildDecorator;
  @ViewChild('config_modal') configModalTemplateRef: ViewChildDecorator;

  @Input() pageHeader: PageHeaderInterface = {
    title: null,
    titleKey: null,
    icon: null,
    fullScreenButton: false,
    fullScreenTargetElementId: null,
    hideHeader: false,
  };
  @Input() large: boolean = false;
  public mode: boolean = false;

  public configModalRef: NgbModalRef;
  public modalArray: NgbModalRef[] = [];
  public changesMade: boolean = false;
  private readonly scwModalSm: string = 'scw-modal-sm';
  public userConfigurationData: IUserConfiguration = null;
  public saveChangedModalRef: NgbModalRef;
  private readonly storeSubscriptions: Subscription[] = [];
  public tabs: PageConfigurationInterface[] = [
    {
      table: [],
      widget: [],
    },
  ];
  public initialTabs: PageConfigurationInterface[] = [
    {
      table: [],
      widget: [],
    },
  ];
  public tableLabelTranslation: string = 'Select and order the widgets as you want';
  public productionReviewInfoMessage: string = 'pageConfiguration.modal.productionReview.info.message';
  public columns: TableColumnInterface[] = [];
  public tabsToBeAtTheEnd: TableConfigurationInterface[] = [];
  public rows: TableConfigurationInterface[] = [];
  public tableColumns$: TableColumnInterface[] = [];
  public tabsToSubmit: TabRowInterface[] = [];
  public isSortable: boolean = true;
  public addDashboardModeSwitch: boolean;
  private applyModeChange: boolean = true;
  public tableConfigHasRow: boolean = false;

  public deviceManagementTableHeaderDefaults: ITableHeader[] = [
    {
      value: null,
      name: '',
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'deviceTypeId',
      name: 'Device Type',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'macAddress',
      name: 'MAC Address',
      disabled: true,
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'connectionStatus',
      name: 'Connection Status',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'connectionProfile',
      name: 'Connection Profile',
      disabled: true,
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'eventHubTopic',
      name: 'EventHub Topic',
      disabled: true,
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'status',
      name: 'Status',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'createdAt',
      name: 'Add Date',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'description',
      name: 'Description',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'orderCode',
      name: 'Order Code',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    // {
    //   value: 'firmwareId',
    //   name: 'Firmware Update',
    //   selected: true,
    //   type: PageConfigurationTypes.TABLE,
    // },
    {
      value: 'firmwareActual',
      name: 'Actual Firmware',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'azureConnectionString',
      name: 'Azure Connection String',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'scwEnv',
      name: 'SCW Env',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'client',
      name: 'Client',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'site',
      name: 'Site',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'line',
      name: 'Line',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
  ];

  public readonly usersTableHeadersDefaults: ITableHeader[] = [
    {
      value: null,
      name: '',
      sortable: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'fullName',
      name: 'general.dataTable.header.fullName',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'userName',
      name: 'general.dataTable.header.username',
      selected: true,
      disabled: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'levelId',
      name: 'general.dataTable.header.level',
      selected: true,
      sortable: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'email',
      name: 'general.dataTable.header.email',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'isActive',
      name: 'general.dataTable.header.status',
      selected: true,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'phone',
      name: 'general.dataTable.header.phone',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'checkInCardId',
      name: 'general.dataTable.header.checkInCardId',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'multipleCheckIns',
      name: 'general.dataTable.header.multipleCheckIns',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'userLanguage',
      name: 'general.dataTable.header.userLanguage',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'locale',
      name: 'general.dataTable.header.locale',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'dateFormat',
      name: 'general.dataTable.header.dateFormat',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'currentSite',
      name: 'general.dataTable.header.currentSite',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'currentLine',
      name: 'general.dataTable.header.currentLine',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'defaultSite',
      name: 'general.dataTable.header.defaultSite',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'timeZone',
      name: 'general.dataTable.header.timezone',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'contactType',
      name: 'general.dataTable.header.contactType',
      selected: false,
      sortable: false,
      type: PageConfigurationTypes.TABLE,
    },
    {
      value: 'details',
      name: 'general.dataTable.header.details',
      selected: false,
      type: PageConfigurationTypes.TABLE,
    },
  ];

  private initialMode: boolean;
  private widgetDataIndex: number = 2;
  private tableDataIndex: number = 1;

  constructor(
    private readonly configModal: NgbModal,
    private readonly store: Store<IotDeviceManagementPortalAppState>,
    private readonly actionsSubject: ActionsSubject,
    private readonly saveChangesModal: NgbModal,
    private readonly helperService: HelperService,
  ) {}

  ngOnInit(): void {
    // const pagesToAddDashboardModeSwitch: string[] = ['work_orders', 'production_review'];
    // this.addDashboardModeSwitch = pagesToAddDashboardModeSwitch.includes(this.pageHeader.titleKey);

    this.storeSubscriptions.push(
      this.store.select('userConfigurationStore').subscribe((state: UserConfigurationStateInterface) => {
        if (state.userConfigurationDataLoaded && !state.userConfigurationDataLoading) {
          this.userConfigurationData = state.userConfigurationData;
          this.getTabs(this.pageHeader.titleKey, state.userConfigurationData, false);
        }
      }),
    );
  }

  drop($event: CdkDragDrop<string[]>, data): void {
    this.changesMade = true;
    moveItemInArray(data, $event.previousIndex, $event.currentIndex);
  }

  public showModal(templateRef: TemplateRef<any>): void {
    this.configModalRef = this.configModal.open(templateRef, {
      keyboard: false,
      backdrop: 'static',
      windowClass: this.scwModalSm,
    });
    this.modalArray.push(this.configModalRef);
    // this.tableConfigHasRow = this.tabs[0].table.some((item) => item?.isTableRow);
  }

  public getTabs(pageHeaderKey: string, userConfigurationData: IUserConfiguration, modeChange: boolean): void {
    this.resetParameters();
    switch (pageHeaderKey) {
      case 'users':
        this.iterateOverDefault(
          this.usersTableHeadersDefaults,
          userConfigurationData,
          ComponentNamesForUserConfiguration.UserSettings,
        );
        break;

      case 'device-management':
        this.iterateOverDefault(
          this.deviceManagementTableHeaderDefaults,
          userConfigurationData,
          ComponentNamesForUserConfiguration.DeviceManagement,
        );

        break;
    }
    this.tabsToBeAtTheEnd.forEach((tab) => {
      this.tabs[0].table[this.tabs[0].table.length] = {
        name: tab.name,
        selected: tab.selected,
        title: tab.title,
        disabled: tab.disabled ? tab.disabled : false,
        sortable: tab?.sortable,
        isTableRow: tab?.isTableRow,
        linkedTo: tab.linkedTo ? tab.linkedTo : null,
        type: PageConfigurationTypes.TABLE,
      };
    });

    this.rows.forEach((tab) => {
      this.tabs[0].table.push({
        name: tab.name,
        selected: tab.selected,
        title: tab.title,
        disabled: tab.disabled ? tab.disabled : false,
        sortable: tab?.sortable,
        isTableRow: tab?.isTableRow,
      });
    });

    if (this.applyModeChange) {
      this.initialTabs = _.cloneDeep(this.tabs);
      this.apply(false);
      this.applyModeChange = false;
    }
  }

  private arrangeHeaders(
    defaultHeaders: any[],
    userConfigurationData: any,
    component: string,
    checkedItemIndex: number,
  ): number {
    const componentDataFromUserConfig = _.get(userConfigurationData, component);
    let result = checkedItemIndex;

    for (const tab of defaultHeaders) {
      if (componentDataFromUserConfig) {
        result = componentDataFromUserConfig[0].value.findIndex((item: number) => item === tab.value);
      }

      if (result !== -1 && !tab?.isTableRow) {
        this.tabs[0].table[result] = {
          name: tab.value,
          selected: true,
          title: tab.name,
          disabled: tab.disabled,
          sortable: tab?.sortable,
          isTableRow: tab?.isTableRow,
        };
        continue;
      }

      if (result !== -1 && tab?.isTableRow) {
        this.rows.push({
          name: tab.value,
          selected: true,
          title: tab.name,
          disabled: tab.disabled,
          sortable: tab?.sortable,
          isTableRow: tab?.isTableRow,
        });
        continue;
      }

      if (checkedItemIndex === -1 && tab.value !== null) {
        this.tabsToBeAtTheEnd.push({
          name: tab.value,
          selected: _.isNil(componentDataFromUserConfig) ? tab?.selected ?? false : false,
          title: tab.name,
          disabled: tab.disabled,
          sortable: tab?.sortable,
          isTableRow: tab?.isTableRow,
        });
      }
    }

    return result;
  }

  public apply(setAsDefault: boolean): void {
    this.applyModeChange = true;
    this.changesMade = false;
    this.tabsToSubmit = [];
    this.iterateTabsToSubmit();
    this.configModalRef?.close();
    this.initialTabs = _.cloneDeep(this.tabs);
    this.initialMode = this.mode;

    if (this.saveChangedModalRef) {
      this.saveChangedModalRef.close();
    }

    if (this.addDashboardModeSwitch) {
      this.store.dispatch(new PageHeaderActions.UpdateFilterBarVisibility(!this.mode));
    }

    switch (this.pageHeader.titleKey) {
      case 'users':
        this.store.dispatch(new UserActions.SetTableSettings(this.tabsToSubmit, setAsDefault));
        break;
      case 'device-management':
        this.store.dispatch(new DeviceActions.SetTableSettings(this.tabsToSubmit, setAsDefault));
        break;
    }
  }

  public dontApply(): void {
    this.changesMade = false;
    if (this.initialMode !== this.mode) {
      this.mode = this.initialMode;
    }
    this.saveChangedModalRef.close();
    this.onCloseClick();
    this.tabs = _.cloneDeep(this.initialTabs);
  }

  public changeCheckBox(event: MatCheckboxChange, tableConfig: boolean): void {
    this.changesMade = true;

    if (tableConfig) {
      PageConfigurationComponent.checkLinkedCheckbox(event.source.id.substring(22), this.tabs[0].table);
      this.tabs[0].table = PageConfigurationComponent.sortTableColumns(this.tabs[0].table, this.isSortable);
    } else {
      PageConfigurationComponent.checkLinkedCheckbox(event.source.id.substring(23), this.tabs[0].widget);
      this.tabs[0].widget = PageConfigurationComponent.sortTableColumns(this.tabs[0].widget, this.isSortable);
    }
  }

  private static sortTableColumns(columnArray, isSortable): any[] {
    if (!isSortable) {
      return columnArray;
    }

    const tableRows = columnArray.filter((c: any) => c.isTableRow);
    const tableColumns = columnArray
      .filter((c: any) => !c.isTableRow)
      .sort((a, b) => (a.selected === b.selected ? 0 : a.selected ? -1 : 1));

    return [...tableColumns, ...tableRows];
  }

  private static getCopyOfFilterArray(filterArray): WidgetDataInterface[] {
    return filterArray.map((filterConfiguration) => {
      if ('children' in filterConfiguration && filterConfiguration.children.length > 0) {
        return {
          ...filterConfiguration,
          children: filterConfiguration.children.map((child) => ({ ...child })),
        };
      }

      return { ...filterConfiguration };
    });
  }

  public onCloseClick(): void {
    if (this.changesMade) {
      this.saveChangedModalRef = this.saveChangesModal.open(this.unsavedChangesModalTemplateRef, {
        keyboard: false,
        backdrop: 'static',
        windowClass: this.scwModalSm,
      });
      this.modalArray.push(this.saveChangedModalRef);
    } else {
      this.configModalRef.close();
    }
  }

  private iterateTabsToSubmit(): void {
    this.tabs[0].table.forEach((tab, index) => {
      this.tabsToSubmit.push(this.tabs[0].table[index]);
    });
    this.tabs[0].widget.forEach((widget, index) => {
      this.tabsToSubmit.push(this.tabs[0].widget[index]);
    });
  }

  public cdkDropListEnterPredicateColumn($event: any): boolean {
    return !Boolean($event?.isTableRow);
  }

  private iterateOverDefault(
    headerDefaults: ITableHeader[],
    userConfigurationData,
    page: ComponentNamesForUserConfiguration,
    isViewPage: boolean = false,
  ): void {
    this.resetParameters();
    let checkedItemIndex: number = -1;
    let selectedColumnIndex: number = -1;
    if (userConfigurationData[page] && !isViewPage) {
      selectedColumnIndex = userConfigurationData[page].findIndex((item) => item.name === 'selectedColumns');
    } else if (userConfigurationData[page] && isViewPage) {
      selectedColumnIndex = this.tableDataIndex;
    }

    headerDefaults.forEach((tab, index) => {
      if (userConfigurationData[page] && selectedColumnIndex !== -1 && !isViewPage) {
        checkedItemIndex = userConfigurationData[page][selectedColumnIndex].value.findIndex(
          (item) => item.name === tab.value,
        );
      } else if (userConfigurationData[page] && selectedColumnIndex !== -1 && isViewPage) {
        checkedItemIndex = userConfigurationData[page][selectedColumnIndex].value.findIndex(
          (item) => item === tab.value,
        );
      }

      if (checkedItemIndex !== -1 && this.isSortable) {
        this.tabs[0].table[checkedItemIndex] = {
          name: tab.value,
          selected: true,
          title: tab.name,
          disabled: tab.disabled,
          linkedTo: tab.linkedTo ? tab.linkedTo : null,
          type: PageConfigurationTypes.TABLE,
        };
      } else if (
        checkedItemIndex === -1 &&
        tab.value !== null &&
        tab.type === PageConfigurationTypes.TABLE &&
        this.isSortable
      ) {
        this.tabsToBeAtTheEnd.push({
          name: tab.value,
          selected: selectedColumnIndex === -1 ? headerDefaults[index].selected : false,
          title: tab.name,
          disabled: tab.disabled,
          linkedTo: tab.linkedTo ? tab.linkedTo : null,
          type: tab.type,
        });
      } else if (!this.isSortable && checkedItemIndex === -1) {
        this.tabs[0].table[index] = {
          name: tab.value,
          selected: selectedColumnIndex === -1 ? headerDefaults[index].selected : false,
          title: tab.name,
          disabled: tab.disabled,
          linkedTo: tab.linkedTo ? tab.linkedTo : null,
          type: PageConfigurationTypes.TABLE,
        };
      } else if (!this.isSortable && checkedItemIndex !== -1) {
        this.tabs[0].table[index] = {
          name: tab.value,
          selected: true,
          title: tab.name,
          disabled: tab.disabled,
          linkedTo: tab.linkedTo ? tab.linkedTo : null,
          type: PageConfigurationTypes.TABLE,
        };
      }
    });

    if (userConfigurationData[page] && !isViewPage) {
      selectedColumnIndex = userConfigurationData[page].findIndex((item) => item.name === 'selectedColumns');
    } else if (userConfigurationData[page] && isViewPage) {
      selectedColumnIndex = this.widgetDataIndex;
    }
  }

  private static checkLinkedCheckbox(
    clickedItemName: string,
    data: TableConfigurationInterface[] | WidgetConfigurationInterface[],
  ): void {
    const clickedItem = _.find(data, { name: clickedItemName });
    if (clickedItem?.linkedTo) {
      const checkbox = _.head(
        document.getElementById(`table-config-checkbox-${clickedItem.linkedTo}`).getElementsByTagName('input'),
      );
      checkbox.click();
    }
  }

  public pageModeChange(isDashboardMode: boolean): void {
    this.changesMade = true;
    this.applyModeChange = false;
    this.mode = isDashboardMode;
    this.getTabs(this.pageHeader.titleKey, this.userConfigurationData, true);
  }

  public resetParameters(): void {
    this.tabsToBeAtTheEnd = [];
    this.tabs[0].table = [];
    this.tabs[0].widget = [];
    this.rows = [];
  }

  ngOnDestroy(): void {
    this.modalArray.forEach((modal: NgbModalRef) => {
      modal.close();
    });
    this.storeSubscriptions.forEach((item: Subscription) => {
      item.unsubscribe();
    });
  }
}
